export default __webpack_public_path__ + "static/media/README.5f07121f.md";